import { gbp, num } from "./bookingCharges";

// Pricing for "Other With Dimension" booking items, set per company in Company Settings.
// The driver and customer mobile apps mirror this in their dimension-pricing.ts, so keep them in sync.
//
// total = max(((L × W × H cm / 1,000,000) + extra_volume) / unit_volume × unit_price, minimum_charge)

// Used until the company saves its own values (the original hardcoded formula)
export const DEFAULT_DIMENSION_PRICING = { unit_price: 90, unit_volume: 0.275, extra_volume: 0.03, minimum_charge: "" };

const round2 = (v) => Math.round(Number(`${num(v).toFixed(10)}e2`)) / 100;
const filled = (v) => v !== "" && v !== null && v !== undefined;

// Accepts the saved object, a JSON string (website config) or nothing, and fills in the defaults
export const resolveDimensionPricing = (raw) => {
  let value = raw;
  if (typeof value === "string") {
    try { value = JSON.parse(value); } catch (e) { value = null; }
  }
  const pricing = { ...DEFAULT_DIMENSION_PRICING };
  Object.keys(pricing).forEach((k) => {
    if (filled(value?.[k])) pricing[k] = value[k];
  });
  return pricing;
};

export const cubicMetres = (length, width, height) => (num(length) * num(width) * num(height)) / 1000000;

// 0 until all three dimensions are entered
export const calculateDimensionTotal = (raw, length, width, height) => {
  const l = parseFloat(length) || 0;
  const w = parseFloat(width) || 0;
  const h = parseFloat(height) || 0;
  if (!l || !w || !h) return 0;

  const pricing = resolveDimensionPricing(raw);
  const unitVolume = num(pricing.unit_volume);
  if (unitVolume <= 0) return 0;

  const subtotal = ((cubicMetres(l, w, h) + num(pricing.extra_volume)) / unitVolume) * num(pricing.unit_price);
  return round2(Math.max(subtotal, num(pricing.minimum_charge)));
};

export const dimensionBreakdown = (raw, length, width, height) => {
  const pricing = resolveDimensionPricing(raw);
  const volume = cubicMetres(length, width, height);
  const units = num(pricing.unit_volume) > 0 ? (volume + num(pricing.extra_volume)) / num(pricing.unit_volume) : 0;
  const subtotal = round2(units * num(pricing.unit_price));
  const minimum = num(pricing.minimum_charge);

  let breakdown = num(pricing.extra_volume) > 0
    ? `(${+volume.toFixed(4)} m³ + ${num(pricing.extra_volume)} m³ allowance)`
    : `${+volume.toFixed(4)} m³`;
  breakdown += ` ÷ ${num(pricing.unit_volume)} m³ = ${+units.toFixed(2)} units × ${gbp(pricing.unit_price)}`;
  if (minimum > subtotal) breakdown += ` → raised to minimum ${gbp(minimum)}`;
  return breakdown;
};
